import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UnitDetails } from '../../../../../../locums/models/unit-details.model';
import { selectJobUnitDetails } from '../../../../../../root-store/locums-store/selectors/job.selector';

@Component({
    selector: 'nova-locums-recruiter-crna-cert',
    templateUrl: './locums-recruiter-crna-cert.component.html',
    styleUrls: ['./locums-recruiter-crna-cert.component.scss']
})
export class LocumsRecruiterCrnaCertificationComponent implements OnInit {
    unitDetails$: Observable<UnitDetails>;
    constructor(private readonly store: Store) {}

    ngOnInit(): void {
        this.unitDetails$ = this.store.select(selectJobUnitDetails);
    }
}
